<template>
  <div class="custom-popup">
    <table class="info-marker-table" style="" dir="rtl">

      <tr>
        <td> المعدة</td>
        <td>{{ point.name}}</td>
      </tr>

      <tr>
        <td>رقم اللوحة</td>
        <td>{{ point.plate}}</td>
      </tr>
      <tr>
        <td>السرعة</td>
        <td>{{ point.speed}}</td>
      </tr>

      <tr>
        <td>الحالة</td>
        <td>{{ point.status}}</td>
      </tr>

      <tr>
        <td>اخر تحديث</td>
        <td>{{ point.devicetime}}</td>
      </tr>


    </table>
  </div>
</template>

<script>
import { timeToString } from '@/utils/time.utils'

export default {
  name: 'MarkerPopup',
  methods: { timeToString },
  props: {
    point: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
.info-marker-table tr {
  border-bottom: 1px solid gray;
}

.leaflet-popup-content-wrapper {
  border-radius: 0 !important;
}
</style>
